var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWeek = function SvgWeek(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 17",
    style: {
      enableBackground: "new 0 0 16 17"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,15.2H3.3c-1.1,0-2.1-0.9-2.1-2V4.8c0-1.1,0.9-1.9,2.1-1.9h1.2V2.4c0-0.4,0.3-0.8,0.8-0.8S6.1,2,6.1,2.4 v0.5h3.8V2.4c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v0.5h1.2c1.1,0,2.1,0.9,2.1,1.9v8.4C14.8,14.3,13.8,15.2,12.7,15.2z M2.8,8v5.2 c0,0.2,0.3,0.5,0.6,0.5h9.3c0.3,0,0.6-0.2,0.6-0.5V8H2.8z M2.8,6.5h10.5V4.8c0-0.2-0.3-0.4-0.6-0.4h-1.2v0.4c0,0.4-0.3,0.8-0.8,0.8 S9.9,5.2,9.9,4.8V4.4H6.1v0.4c0,0.4-0.3,0.8-0.8,0.8S4.6,5.2,4.6,4.8V4.4H3.3C3,4.4,2.8,4.6,2.8,4.8V6.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeek, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/week.41ddbe4d.svg";
export { ForwardRef as ReactComponent };